import { useEffect, useState } from 'react'

export enum FilterType {
  thirtydays = '30 day',
  sixmonths = '6 month',
  twelveMonths = '1 year',
  fiveYear = '5 year',
}

export type PeriodSeriesDataType = {
  date: number
  value: number
}

export interface PeriodData {
  period: string
  change: number
  current: number
  series: PeriodSeriesDataType[]
}

const useHooks = (data?: PeriodData[]) => {
  const [filteredData, setFilteredData] = useState<PeriodData | undefined>()
  const [currentFilter, setCurrentFilter] = useState<FilterType>(
    FilterType.fiveYear
  )
  const [hideFilters, setHideFilters] = useState<boolean>(false)

  const filterDataByRange = (filter: FilterType) => {
    // Why we cloneDeep: https://stackoverflow.com/questions/64791500/data-being-plotted-is-multiplied-by-1000-on-its-own-in-highcharts-using-angular
    const dataToProcess = structuredClone(data)

    const filteredPeriod = dataToProcess?.find(item => item.period === filter)

    setFilteredData(filteredPeriod)
  }

  useEffect(() => {
    if (!data) return

    filterDataByRange(currentFilter)
  }, [currentFilter, data])

  return {
    filteredData,
    setCurrentFilter,
    currentFilter,
    hideFilters,
  }
}

export default useHooks
